// extracted by mini-css-extract-plugin
export var statItem = "_hs-1";
export var statsRow = "_hs-0";